import React, { useEffect, useState } from 'react';
import { ReactComponent as ArrowBack } from '../assets/icons/arrow_back.svg';
import { ReactComponent as ArrowCoolDown } from '../assets/icons/arrow_cool_down.svg';
import { ReactComponent as CheckCircle } from '../assets/icons/check_circle.svg';
import { ReactComponent as Close } from '../assets/icons/close.svg';
import { ReactComponent as Lock } from '../assets/icons/lock.svg';
import { ReactComponent as PlayCircle } from '../assets/icons/play_circle.svg';
import { ReactComponent as Refresh } from '../assets/icons/refresh.svg';
import { ReactComponent as Tune } from '../assets/icons/tune.svg';
import { ReactComponent as VolumeUp } from '../assets/icons/volume_up.svg';
import { ReactComponent as BrandAwareness } from '../assets/icons/brand_awareness.svg';
import { ReactComponent as DisabledByDefault } from '../assets/icons/disabled_by_default.svg';
import { ReactComponent as ChangeCircle } from '../assets/icons/change_circle.svg';
import { ReactComponent as CheckBox } from '../assets/icons/check_box.svg';
import { ReactComponent as Image } from '../assets/icons/image.svg';
import { ReactComponent as MatchWord } from '../assets/icons/match_word.svg';
import { ReactComponent as StylusNote } from '../assets/icons/stylus_note.svg';
import { ReactComponent as Timer3 } from '../assets/icons/timer_3.svg';
import './Icon.css';

const icons = { arrow_back: ArrowBack, arrow_cool_down: ArrowCoolDown,
    check_circle: CheckCircle, close: Close, lock: Lock, play_circle: PlayCircle,
    refresh: Refresh, tune: Tune, volume_up: VolumeUp,
    brand_awareness: BrandAwareness, disabled_by_default: DisabledByDefault,
    change_circle: ChangeCircle, check_box: CheckBox, image: Image,
    match_word: MatchWord, stylus_note: StylusNote, timer_3: Timer3 };

function FontIcon({ name }) {
    const [readyName, setReadyName] = useState(null);

    useEffect(() => {
        let active = true;
        // The local font is requested only when the fallback is actually used.
        if (document.fonts) {
            document.fonts.load('500 24px "Material Symbols Rounded"', name)
                .then(faces => {
                    if (active && faces.length > 0) setReadyName(name);
                })
                .catch(() => { /* Keep the reserved space if the font cannot load. */ });
        }
        return () => { active = false; };
    }, [name]);

    return <span className="app-icon-font" style={{ visibility: readyName === name ? 'visible' : 'hidden' }}>{name}</span>;
}

// useFont allows an explicit rollback; future names missing from the SVG map
// automatically use the original local Material Symbols font.
export default function Icon({ name, className = '', useFont = false, ...props }) {
    const Svg = Object.prototype.hasOwnProperty.call(icons, name) ? icons[name] : null;
    return (
        <span aria-hidden="true" {...props} className={`material-symbols-rounded app-icon ${className}`}>
            {Svg && !useFont
                ? <Svg width="1em" height="1em" fill="currentColor" aria-hidden="true" focusable="false" />
                : <FontIcon name={name} />}
        </span>
    );
}
